import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Accordion, Button, Col, Row } from 'react-bootstrap';
import ShopOfferItem from '../common/ShopOfferItem/ShopOfferItem.jsx';
import PictureModalPlayer from '../common/Player/PictureModalPlayer.jsx';
import Picture from '../common/ShopOfferItem/Picture.jsx';


function PurchasesItem(props) {
  let files;
  if (props.files){
    files = props.files.map(f => <p className='mr-5 small'>
      <a href={ f.url } target='_blank'><i className={ 'icon icon-' + (f.pdf ? 'file-pdf' : 'doc') }></i>{ f.name }</a>
    </p>);
  }
  const imageBlock = <Picture image={ props.offer.thumbnail } title={ props.offer.name } />

  return <ShopOfferItem {...props.offer} notShowPrice={ true } imageBlock={ imageBlock }>
    <p className="small text-muted">{ gettext('Дата покупки') }: { props.date_format }</p>
    <Row className='mb-3'>
      <Col xs={12} md={8}>
        <Accordion>
          <Accordion.Toggle as={ Button } variant="link" eventKey={ `${props.id}_files` }
                            title={ gettext('Показать список файлов') } className='p-0 my-2 btn-sm'>
            <i className='icon icon-docs'></i> { gettext('Список файлов') }
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={`${props.id}_files`}>
            <div>{ files }</div>
          </Accordion.Collapse>
        </Accordion>
      </Col>
      <Col xs={12} md={4} className='text-md-right'>
        <Button href={ props.file_url } variant='link' size='sm' className='mr-2 mb-2 mb-md-0'>
          <i className='icon icon-floppy'></i> {gettext('Скачать материалы')}
        </Button>
      </Col>
    </Row>
    <Row className='mb-3'>
      <Col xs={12} sm={6} md={8}>
        <PictureModalPlayer code={ props.video_code } title={ props.title } author={ props.author }/>
      </Col>
      <Col xs={12} sm={6} md={4} className='text-md-right'>
        {/* @todo выводить здесь форму для отзыва */}
        <Button href={ `${props.offer.url}#add_comment` } variant='outline-dark' size='sm' className='mr-2 mt-2 mt-md-0'>
          <i className='icon icon-comment'></i> { gettext('Оставить отзыв') }
        </Button>
      </Col>
    </Row>
  </ShopOfferItem>
}

PurchasesItem.propTypes = {
  id: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
}

export default compose(connect(null, {}))(PurchasesItem);

